module.exports = __webpack_public_path__ + "img/国防科技大学第六十三研究院.7e5097ad.png";